import React, { useState } from "react";
import { Link as ReactRouterLink } from "react-router-dom";
import { Box, Link as ChakraLink, Divider, SimpleGrid } from "@chakra-ui/react";
import { motion } from "framer-motion";
import * as logo from "../../assets";
import Marquee from "react-fast-marquee";
import project1 from "../../assets/project-1.png";
import project2 from "../../assets/project-2.png";
import project3 from "../../assets/project-3.png";
import project4 from "../../assets/project-4.png";

const cardsData = [
  {
    contents:
      "HTML/CSS/JavaScript, PHP, C#, MySQL, PostgreSQL, mongoDB, React.js (JSX, TSX), NEXT.js, Laravel, .NET, Tailwind, Bootstrap",
    title: "Full-stack Development",
    subtitle:
      "Let's work together to create websites and interfaces that find solutions, make results, and bring joy to your users.",
    img: (
      <>
        <img src={logo.html} alt="" className="w-auto h-12" />
        <img src={logo.css} alt="" className="w-auto h-12" />
        <img src={logo.js} alt="" className="w-auto h-12 rounded-lg" />
        <img src={logo.php} alt="" className="w-auto h-12" />
        <img src={logo.csharp} alt="" className="w-auto h-12" />
        <img src={logo.mysql} alt="" className="w-auto h-12" />
        <img src={logo.postgre} alt="" className="w-auto h-12" />
        <img src={logo.mongodb} alt="" className="w-auto h-12" />
        <img src={logo.react} alt="" className="w-auto h-12" />
        <img src={logo.next} alt="" className="w-auto h-12" />
        <img src={logo.Laravel} alt="" className="w-auto h-12" />
        <img src={logo.ado} alt="" className="w-auto h-12" />
        <img src={logo.tailwind} alt="" className="w-auto h-12 rounded-lg" />
        <img src={logo.bootstrap} alt="" className="w-auto h-12 mr-8" />
      </>
    ),
  },
  {
    contents: "Figma, Canva, Adobe Illustrator, Adobe Photoshop",
    title: "UI/UX & Graphic Design",
    subtitle:
      "Let's collaboratively craft websites and interfaces that tackle challenges, drive outcomes, and bring joy to your users.",
    img: (
      <>
        <img src={logo.figma} alt="" className="w-auto h-12" />
        <img src={logo.canva} alt="" className="w-12 h-auto rounded-xl" />
        <img src={logo.illustrator} alt="" className="w-12 h-auto" />
        <img src={logo.photoshop} alt="" className="w-12 h-auto mr-14" />
      </>
    ),
  },
  // {
  //   contents: "",
  //   title: "UI/UX Designer",
  //   subtitle: "These absolutely deserve to exist.",
  // },
];

const Card = ({ contents, title, subtitle, img, index }) => {
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });
  const [isHovered, setIsHovered] = useState(false);
  const animationDelay = 0.5 + index * 0.5;

  const handleMouseMove = (e) => {
    const card = e.currentTarget;
    const rect = card.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    card.style.setProperty("--mouse-x", `${x}px`);
    card.style.setProperty("--mouse-y", `${y}px`);
    setMousePos({ x, y });
  };

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.8 }}
      viewport={{ once: true }}
      whileInView={{
        opacity: 1,
        scale: 1,
      }}
      transition={{ duration: 1, delay: animationDelay, ease: "easeInOut" }}
      className="card bg-grey-rgba rounded-lg border-2 border-[#ffffff1a] relative w-full py-14 px-8"
      bg="rgba(255, 255, 255, 0.05)"
      borderRadius="lg"
      display="flex"
      flexDirection="column"
      padding="4em 2em"
      border="2px"
      borderColor="#ffffff1a"
      position="relative"
      width="full"
      onMouseMove={handleMouseMove}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      overflow="hidden"
    >
      <Box
        position="absolute"
        top="0"
        left="0"
        width="100%"
        height="100%"
        bg={`radial-gradient(600px circle at ${mousePos.x}px ${mousePos.y}px, rgba(255, 255, 255, 0.02), transparent 40%)`}
        zIndex="1"
        borderRadius="inherit"
        pointerEvents="none"
        transition="opacity 500ms"
        opacity={isHovered ? 1 : 0}
      />
      <Box
        position="absolute"
        top="0"
        left="0"
        width="100%"
        height="100%"
        bg={`radial-gradient(400px circle at ${mousePos.x}px ${mousePos.y}px, rgba(255, 255, 255, 0.09), transparent 40%)`}
        zIndex="1"
        borderRadius="inherit"
        pointerEvents="none"
        transition="opacity 500ms"
        opacity={isHovered ? 1 : 0}
      />
      <h3 className="text-txt text-base xl:text-xl font-medium">{title}</h3>
      <Marquee gradientColor="#000">
        <Box className="flex gap-14 py-8 align-middle">{img}</Box>
      </Marquee>
      <p className="text-txt font-light text-sm xl:text-lg">{subtitle}</p>
      <p className="text-zinc-500 font-light text-sm xl:text-lg mt-4">
        {contents}
      </p>
    </motion.div>
  );
};

const Main = () => {
  return (
    <div>
      <motion.h2
        initial={{ opacity: 0, y: -40 }}
        viewport={{ once: true }}
        whileInView={{
          opacity: 1,
          y: 0,
        }}
        transition={{ duration: 1, delay: 0.2, ease: "easeInOut" }}
        className="text-txt text-xl sm:text-3xl lg:text-5xl font-normal mb-10 mt-14 md:mt-24 text-center"
      >
        Empowering Experiences Through Technology and Design.
      </motion.h2>

      {/* <motion.p
        initial={{ opacity: 0 }}
        viewport={{ once: true }}
        whileInView={{
          opacity: 1,
        }}
        transition={{ duration: 1, delay: 0.4, ease: "easeInOut" }}
        className="text-zinc-500 text-sm sm:text-2xl lg:text-4xl 2xl:px-48 font-light mb-8 md:mb-12 2xl:text-center"
      >
        As a full-stack developer, UI/UX skilled, and graphic designer, I blend
        my technical expertise with a strong artistic vision to develop
        seamless, engaging, and visually appealing digital experiences.
      </motion.p> */}

      <SimpleGrid columns={[1, null, 2]} gap={4}>
        {cardsData.map((card, index) => (
          <Card key={index} index={index} {...card} />
        ))}
      </SimpleGrid>

      <Divider sx={{ my: 24 }} />

      <motion.h2
        id="projects"
        initial={{ opacity: 0, y: -40 }}
        viewport={{ once: true }}
        whileInView={{
          opacity: 1,
          y: 0,
        }}
        transition={{ duration: 1, delay: 0.2, ease: "easeInOut" }}
        className="text-txt text-xl sm:text-3xl lg:text-5xl xl:px-4 font-normal mb-1 md:mb-5 text-center"
      >
        Step into my world of ingenuity and creativity
      </motion.h2>

      <section>
        <Box className="flex flex-col justify-center items-center gap-5 mt-8 md:mt-12">
          <div className="flex flex-col lg:flex-row gap-5">
            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{
                opacity: 1,
              }}
              viewport={{ once: true }}
              transition={{
                duration: 1,
                delay: 0.5,
                ease: "easeIn",
              }}
              className="w-full h-full overflow-hidden"
            >
              <a
                href="https://dkdmarketing.vercel.app/"
                target="_blank"
                rel="noreferrer"
              >
                <div className="w-full h-full overflow-hidden rounded md:rounded-xl">
                  <motion.img
                    whileHover={{ scale: 1.12 }}
                    transition={{ duration: 0.2, ease: "easeOut" }}
                    className="object-cover"
                    src={project1}
                    alt="project-1"
                    loading="lazy"
                  />
                </div>
              </a>
            </motion.div>

            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{
                opacity: 1,
              }}
              viewport={{ once: true }}
              transition={{
                duration: 1,
                delay: 0.8,
                ease: "easeIn",
              }}
              className="w-full h-full overflow-hidden"
            >
              <a
                href="https://www.sale-savant.com/"
                target="_blank"
                rel="noreferrer"
              >
                <div className="w-full h-full overflow-hidden rounded md:rounded-xl">
                  <motion.img
                    whileHover={{ scale: 1.12 }}
                    transition={{ duration: 0.2, ease: "easeOut" }}
                    className="object-cover"
                    src={project2}
                    alt="project-2"
                    loading="lazy"
                  />
                </div>
              </a>
            </motion.div>
          </div>

          <div className="flex flex-col lg:flex-row gap-5">
            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{
                opacity: 1,
              }}
              viewport={{ once: true }}
              transition={{
                duration: 1,
                delay: 0.8,
                ease: "easeIn",
              }}
              className="w-full h-full display-1 overflow-hidden"
            >
              <a
                href="https://solution-deck.netlify.app/"
                target="_blank"
                rel="noreferrer"
              >
                <div className="w-full h-full overflow-hidden rounded md:rounded-xl">
                  <motion.img
                    whileHover={{ scale: 1.12 }}
                    transition={{ duration: 0.2, ease: "easeOut" }}
                    className="object-cover"
                    src={project3}
                    alt="project-3"
                    loading="lazy"
                  />
                </div>
              </a>
            </motion.div>

            <motion.iv
              div
              initial={{ opacity: 0 }}
              whileInView={{
                opacity: 1,
              }}
              viewport={{ once: true }}
              transition={{
                duration: 1,
                delay: 0.8,
                ease: "easeIn",
              }}
              className="w-full h-full overflow-hidden"
            >
              <a
                href="https://www.google.com/"
                target="_blank"
                rel="noreferrer"
              >
                <div className="w-full h-full overflow-hidden rounded md:rounded-xl">
                  <motion.img
                    whileHover={{ scale: 1.12 }}
                    transition={{ duration: 0.2, ease: "easeOut" }}
                    className="object-cover"
                    src={project4}
                    alt="project-4"
                    loading="lazy"
                  />
                </div>
              </a>
            </motion.iv>
          </div>

          <ChakraLink
            as={ReactRouterLink}
            to="/projects"
            style={{ color: "white" }}
            className="bg-zinc-900 hover:bg-[#6778cb] w-fit rounded-full mt-10 py-3 px-6 flex flex-row items-center gap-1 border border-zinc-800 hover:border-indigo-500 transition duration-300"
          >
            View All Projects
          </ChakraLink>
        </Box>
      </section>
    </div>
  );
};

export default Main;
